export default {
  labelCancelButton: 'Cancel',
  labelAction: 'Action',
  labelEdit: 'Edit',
  labelDelete: 'Delete',
  labelRegister: 'Register',
  labelInputRequired: 'Input required.',
  labelLengthExceeded: 'Please enter {max} characters or less.',
  labelNoAppointmentBtn: 'No appointment<br />visitor',
  labelDefaultAppointments: 'Appointments',
  labelVisitorDialog:
    'Please enter your company name, your name, and the purpose of your visit.',
  labelVisitorName: 'company name / your name',
  labelVisitorReason: 'purpose',
  visitReasonOther: 'Other',
  labelCallButton: 'Call',
  waitingForWIFIMessage: 'Waiting for WIFI connection......',
  loadingMessage: 'Loading......',
  loadingErrorMessage:
    'Could not connect to the server. Please close the application and try again later.',
  callingMessage: 'Now calling, please wait.',
  visitorNotifyMessage: '{name} has arrived for {reason}.',
  errorReasonLogin: 'Could not log in to the server.',
  errorReasonServerConnection:
    'Error has occurred while communicating with the server.',
  errorReasonRegularButtonSettings:
    'Could not get the regular buttons settings.',
  errorReasonReservationSettings: 'Could not get the reservation settings.',
  errorReasonDisplaySettings: 'Could not get the display settings.',
  errorReasonPutDisplaySettings: 'Could not update the display settings.',
  errorReasonVoiceSettings: 'Could not get the voice settings.',
  errorReasonPostReservation: 'Could not register the reservation.',
  errorReasonPutReservation: 'Could not update the reservation.',
  errorReasonDeleteReservation: 'Could not delete the reservation.',
  errorReasonOther: 'Something went wrong.',
  errorReasonNoValidContracts: 'No valid contracts were found.',
  labelEditPageTitle: "Touch'n Call Settings",
  labelGeneralSettings: 'General Settings',
  descriptionGeneralSettings:
    'Set background and title of the reception and reservation screen.',
  labelRegularsSettings: 'Regular Buttons Settings',
  descriptionRegularsSettings:
    'Set layouts, images, titles, and calling message for the regular buttons.',
  labelReservationsManage: 'Reservations Management',
  descriptionReservationsManage: 'Create, modify, delete the reservation.',
  labelCallingSettings: 'Calling Settings',
  descriptionCallingSettings:
    'Set the display time and notifications to Microsoft Teams.',
  labelNoAppointmentSettings: 'No appointment guest Settings',
  descriptionNoAppointmentSettings: 'Set the items for no appointment guests.',
  labelCountOfButtons: 'Count of buttons',
  labelDisplayType: 'Display Type',
  itemDisplayTypeImage: 'Image only',
  itemDisplayTypeImageLabel: 'Image and Label',
  itemDisplayTypeLabel: 'Label only',
  labelDisplayText: 'Display Label',
  labelVoiceMessage: 'Calling Message',
  labelGenerateVoice: 'Generate Voice',
  labelSave: 'Save',
  labelDisplayImage: 'Display image',
  pleaseSelectAnyButtonToEdit: 'Please select any button to edit.',
  labelHome: 'Home',
  labelReservationDate: 'Reservation date and time',
  labelReservationDisplayPeriod: 'Display period',
  labelReservationCreateButton: 'New reservation',
  labelNoReservation: 'There are no reservations.',
  labelConfirmReservationDeleting:
    'Are you sure you want to delete this reservation?',
  labelReservationEdit: 'Edit reservation',
  labelReservationCreate: 'Create new reservation',
  labelReservationSpecifyTime: 'with time',
  labelReservationSpecifyPeriod: 'set a display period',
  labelReservationBeginDate: 'from',
  labelReservationEndDate: 'to',
  speakerSearchingMessage: 'Searching the smart speakers......',
  labelSpeakerSelect: 'Select the speaker.',
  labelSpeakerNotFound: 'Not found the smart speakers',
  labelSpeakerTable: 'Result',
  labelVoiceTestButton: 'Voice Test',
  labelSearchRetryButton: 'Retry',
  labelToReceptViewButton: 'To Recept View',
  noAppointmentToday: 'No appointments today.',
  labelCallingDisplayTime: 'Display time of calling screen',
  labelCallingDisplayTimeUnit: 'seconds',
  labelTeamsSettings: 'Notifications to Microsoft Teams',
  labelTeamsNotifyUrl: 'URL',
  labelTeamsNotifyTitle: 'Title',
  labelTeamsNotifyColor: 'Color',
  labelTeamsNotifyFormat: 'Format',
  labelTeamsNotifyFormatHint:
    'The "{message}" will be replaced by the actual message.',
  labelBackgroundColor: 'Background color',
  labelReceptionTitle: 'Reception title',
  labelReservationTitle: "Today's reservations title",
};
